import { render } from "./BannerTitle.vue?vue&type=template&id=0b7bd3f0&scoped=true"
import script from "./BannerTitle.vue?vue&type=script&lang=js"
export * from "./BannerTitle.vue?vue&type=script&lang=js"

import "./BannerTitle.vue?vue&type=style&index=0&id=0b7bd3f0&lang=scss&scoped=true"

import exportComponent from "C:\\projects 2022\\helmets-nepal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7bd3f0"]])

export default __exports__